/* Urban Lux — EMS Pro landing: reveals + FAQ accordion. Vanilla, sin librerías. */
(function () {
  function initReveals() {
    var els = document.querySelectorAll('.mt-ems-reveal');
    if (!els.length) return;
    els.forEach(function (el) { el.classList.add('mt-armed'); });
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px 400px 0px' });
    els.forEach(function (el) { io.observe(el); });
    /* Red de seguridad: si por lo que sea el observer no revela algo
       (pestaña en segundo plano, navegador raro, etc.), nunca se queda
       invisible para siempre. */
    setTimeout(function () {
      els.forEach(function (el) { el.classList.add('is-visible'); });
    }, 2500);
  }

  function initFaq() {
    var items = document.querySelectorAll('.mt-ems-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector('.mt-ems-faq__q');
      var a = item.querySelector('.mt-ems-faq__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        var group = item.closest('.mt-ems-faq__list');
        if (group) {
          group.querySelectorAll('.mt-ems-faq__item.is-open').forEach(function (o) {
            o.classList.remove('is-open');
            var oa = o.querySelector('.mt-ems-faq__a');
            if (oa) oa.style.maxHeight = null;
          });
        }
        if (!open) {
          item.classList.add('is-open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }

  function initScrollToProduct() {
    var btns = document.querySelectorAll('[data-scroll-to-product]');
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var target = document.querySelector('.product, product-info, #MainContent .shopify-section');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function init() { initReveals(); initFaq(); initScrollToProduct(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
